import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

// import { deviceLayout } from 'styles/breakpoint'

export const StyledSlider = styled.div`
  .noteInput {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    cursor: pointer;
    span {
      font-size: 13px;
      line-height: 18px;
      color: #2d87f3;
      text-decoration: underline;
    }
  }
`

export const StyledSubmitButton = styled.div`
  margin: 0 auto;
  width: 100%;

  & > :not(:last-child) {
    margin-bottom: 8px;
  }

  ${MediaQueries.mbUp} {
    max-width: 195px;
  }
`

export const StyledInfo = styled.div`
  ${MediaQueries.mbUp} {
    padding-left: 16px;
    padding-right: 16px;
  }

  padding-bottom: 60px;
  border-bottom: 8px solid #f7f9fc;
`

export const StyledBMIInfo = styled.div`
  & > :not(:last-child) {
    margin-bottom: 28px;
  }
`

export const StyledRightColumnContainer = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;
`

export const StyledTab = styled.div`
  margin-bottom: 24px;

  ${MediaQueries.mbUp} {
    padding-left: 16px;
    padding-right: 16px;
  }
`

export const StyledTabContent = styled.div`
  margin-bottom: 56px;
  line-height: 24px;

  & > :first-of-type {
    margin-bottom: 8px;
  }

  ${MediaQueries.mbUp} {
    padding-left: 16px;
    padding-right: 16px;
  }
`

export const StyledInfoCard = styled.div`
  padding-top: 32px;

  & > div {
    margin-bottom: 24px;
  }

  ${MediaQueries.mbUp} {
    padding-left: 16px;
    padding-right: 16px;
  }
`

export const StyledActive = styled.div`
  margin-bottom: 24px;
  width: 100%;

  ${MediaQueries.mbUp} {
    padding: 0 16px;
  }
  .card {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > :not(:last-child) {
      margin-bottom: 8px;
    }

    .gender-selector {
      row-gap: 12px;

      & > :not(:last-child) {
        margin-right: 16px;
      }

      & > div {
        ${MediaQueries.mbUp} {
          width: calc(18% - 4px);
          max-width: 186px;
          justify-self: left;
        }

        ${MediaQueries.mbDown} {
          width: calc(31% - 8px);
          max-width: 109px;
          justify-self: left;
        }
      }
    }

    .gender-image {
      width: 23px;
      height: 36px;
      object-fit: contain;
    }
  }
  .note {
    display: flex;
    align-items: center;
    padding-top: 8px;
    padding-bottom: 16px;
  }
`
export const StyledIdeal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  margin: 18px 0;
  gap: 32px;
  width: 100%;

  border: 1px solid #e4e8ec;
  box-sizing: border-box;
  border-radius: ${theme.borderRadius};
`
export const StyledIdealTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
`
export const StyledIdealContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
`
export const StyledIdealCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  height: 186px;
  padding: 0 16px;
  h6 {
    text-align: center;
  }
`
